import { render, staticRenderFns } from "./pop_up_code.vue?vue&type=template&id=2b2febda&scoped=true&lang=pug&"
import script from "./pop_up_code.vue?vue&type=script&lang=js&"
export * from "./pop_up_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2febda",
  null
  
)

export default component.exports